import { EnvInfoResponse } from '@sxm-de/dev-kits/microservices-sdk/types';
import { msGet } from '@sxm-de/dev-kits/microservices-sdk/utils';

export type EnvInfoFn = () => Promise<EnvInfoResponse>;

export function initEnvInfoFn({ baseUrl }: { baseUrl: string }): EnvInfoFn {
    return async () => {
        const url = `${baseUrl}/utility/env-info`;
        return await msGet<EnvInfoResponse>(url);
    };
}
